const localization = {
    cannot_delete_default_language: '{{languageTag}} 언어는 기본 언어이므로 삭제할 수 없어요.',
    invalid_translation_structure: '유효하지 않은 데이터 스키마예요. 입력된 값을 다시 확인해 주세요.',
};
export default localization;
